const appInfo = {
    title: 'Manisoft'
};
export default appInfo;

